import React from 'react';
import ClassAssembly11A from 'views/ClassAssembly11A';

const ClassAssembly11APage = () => {
    return <ClassAssembly11A />;
  };
  
  export default ClassAssembly11APage;

  //11A